"use client"

import React, {useRef, useState, useEffect} from 'react';
import {Link} from "@pata/i18n";
import {useTranslations} from "next-intl";

export type Props = {
    children: React.ReactNode;
    backLink?: boolean;
};

export default function SectionLeftClient(props: Props) {
    const targetRef = useRef<HTMLDivElement>(null);
    const [isFixed, setIsFixed] = useState(false);
    
    useEffect(() => {
        if (!targetRef.current) return;
        const bodyElement = document.querySelector('body > .page-body');
        
        let scrollThreshold: number | null = null
        if (bodyElement) {
            scrollThreshold = window.scrollY + bodyElement.getBoundingClientRect().top
        }
        
        const onScroll = () => {
            if (!targetRef.current) return;
            if (null === scrollThreshold) return;
            
            if (scrollY >= scrollThreshold) {
                if (!isFixed) setIsFixed(true);
            } else {
                if (isFixed) setIsFixed(false);
            }
        };
        
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [targetRef, isFixed]);
    
    const goBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        window.history.back();
    }
    
    const t = useTranslations('SectionLeft')
    return (
        <>
            <div ref={targetRef} className={`left${isFixed ? ' fixed' : ''}`}>
                {props.children}
                {props.backLink
                    ? (<Link className="return-link" href="#" onClick={goBack}>{t('back')}</Link>)
                    : (<Link className="return-link" href="/">{t('toHomepage')}</Link>)
                }
            </div>
        </>
    )
}